import React, { useEffect, useState } from 'react';
import './styles.css';
import AlertInfo from '../../helpers/AlertInfo';

import i18n from '../../translate/i18n'

// SERVICES
import { getOsFromUser, getOsAVGRes, getOsAVGGrade, getOsMonthly } from '../../services/OsService';

//COMPONENTS
import Template from '../../components/Template';
import WidgetChartGroupedBar from '../../components/Widgets/WidgetChartGroupedBar';
import WidgetChartDoughnut from '../../components/Widgets/WidgetChartDoughnut';
import WidgetChartProcess from '../../components/Widgets/WidgetChartProcess';
import WidgetCard from '../../components/Widgets/WidgetCard';
import WidgetMap from '../../components/Widgets/WidgetMap';


export default function Home() {
  const [data, setData] = useState<any[]>();
  const [processosTotal, setProcessosTotal] = useState<number>(0);
  const [processosRegulares, setProcessosRegulares] = useState<number>(0);
  const [processosIrregulares, setProcessosIrregulares] = useState<number>(0);
  const [processosFinalizados, setProcessosFinalizados] = useState<number>(0);
  const [ProcessosAndamento, setProcessosAndamento] = useState<number>(0);
  const [processosTempoMedio, setProcessosTempoMedio] = useState<number>(0);
  const [completaTempoMedio, setCompletaTempoMedio] = useState<number>(0);
  const [remotaTempoMedio, setRemotaTempoMedio] = useState<number>(0);
  const [periciaTempoMedio, setPericiaTempoMedio] = useState<number>(0);
  const [labelChart, setLabelChart] = useState<string[]>([])
  const [dataCompletaChart, setDataCompletaChart] = useState<number[]>([])
  const [dataRemotaChart, setDataRemotaChart] = useState<number[]>([])
  const [dataPericiaChart, setDataPericiaChart] = useState<number[]>([])
  const [variationNumberOrders, setVariationNumberOrders] = useState<number>(0);
  const [variationNumberCompletedOrders, setVariationNumberCompletedOrders] = useState<number>(0);
  const [variationNumberOrdersInProgress, setVariationNumberOrdersInProgress] = useState<number>(0);
  const [selectedPeriod, setSelectedPeriod] = useState<string>('');
  const [availablePeriods, setAvailablePeriods] = useState<string[]>([]);

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth()  + 1;
    const periods: string[] = [];

    for (let year = currentYear - 1; year <= currentYear; year++) {
      for (let month = 1; month <= 12; month++) {
        if (year === currentYear && month > currentMonth) break;
        periods.push(`${year}/${month.toString().padStart(2, '0')}`);
      }
    }

    periods.push("Todos");

    setAvailablePeriods(periods.reverse());
    setSelectedPeriod(`${currentYear}/${currentMonth.toString().padStart(2, '0')}`);
  }, []);

  function getMonthlyOrderPercentageDifference(orders: any[], period: string): number {
    if (!period || period === "Todos") return 0;

    const [year, month] = period.split('/').map(Number);
    let previousMonth = month - 1;
    let previousYear = year;
    if (previousMonth < 1) {
      previousMonth = 12;
      previousYear -= 1;
    }

    const currentMonthOrders = orders.filter(order => {
      const createdAt = new Date(order.createdAt);
      return createdAt.getFullYear() === year && createdAt.getMonth() + 1 === month;
    }).length;

    const previousMonthOrders = orders.filter(order => {
      const createdAt = new Date(order.createdAt);
      return createdAt.getFullYear() === previousYear && createdAt.getMonth() + 1 === previousMonth;
    }).length;

    if (previousMonthOrders === 0) {
      return currentMonthOrders === 0 ? 0 : 100;
    }

    return ((currentMonthOrders - previousMonthOrders) / previousMonthOrders) * 100;
  }


  function filterOrdersByPeriod(orders: any[], period: string): any[] {
    if (!period || period === "Todos") return orders;

    const [year, month] = period.split('/').map(Number);
    return orders.filter(order => {
      const createdAt = new Date(order.createdAt);
      return createdAt.getFullYear() === year && createdAt.getMonth() + 1 === month;
    });
  }

  useEffect(() => {
    /*
    AlertInfo(
      'Atualizações na Plataforma - Aprimorando Sua Experiência!',
      `
      <p>
    <p>Estamos entusiasmados em compartilhar melhorias significativas na nossa plataforma visando aprimorar a eficiência da experiência do usuário. As atualizações incluem:</p>
    <br/>
    <p>1. Verificação de Uploads Duplicados: Adeus à confusão - uploads duplicados são automaticamente detectados.</p>
    <p>2. Otimização de Imagens: Imagens agora são otimizadas automaticamente para melhorar a qualidade.</p>
    <p>3. Novo Layout para o Relato: Apresentamos um design moderno e intuitivo para facilitar e proporcionar uma visão mais organizada.</p>
    <p>4. Opção de Alterar Títulos das Etapas do Relato: Maior flexibilidade - personalize os títulos conforme suas preferências.</p>
    <p>5. Nova Organização de Imagens no PDF: Apresentação mais profissional com uma disposição melhorada das imagens no PDF.</p>
    <br/>
    <p>Estas atualizações refletem o nosso compromisso contínuo em oferecer a melhor experiência possível aos usuários.</p>
    </p>
      `
    );
    
*/


    async function getData() {

      const cardData: any = []

      // busca dados de OS
      await getOsFromUser().then(res => {
        // const dataNew = res.data.rows;

        // function filterOrdersByCurrentMonth(orders: any[]): any[] {
        //   const currentDate = new Date();
        //   const currentMonth = currentDate.getMonth() ;
        //   const currentYear = currentDate.getFullYear();

        //   return orders.filter(order => {
        //     const createdAt = new Date(order.createdAt);
        //     return createdAt.getMonth() === currentMonth && createdAt.getFullYear() === currentYear;
        //   });
        // }

        // const filteredOrders = filterOrdersByCurrentMonth(dataNew);

        // setData(filteredOrders)

        const dataNew = filterOrdersByPeriod(res.data.rows, selectedPeriod);

        setData(dataNew);

        const period = selectedPeriod;
        const variationNumberOrders = getMonthlyOrderPercentageDifference(dataNew, period);
        // console.log(`Diferença percentual: ${variationNumberOrders.toFixed(2)}%`);
        setVariationNumberOrders(variationNumberOrders)

        const variationNumberCompletedOrders = getMonthlyOrderPercentageDifference(dataNew.filter((os: any) => os.finalizado === true), period);
        // console.log(`Diferença percentual: ${variationNumberCompletedOrders.toFixed(2)}%`);
        setVariationNumberCompletedOrders(variationNumberCompletedOrders)

        const variationNumberOrdersInProgress = getMonthlyOrderPercentageDifference(dataNew.filter((os: any) => os.finalizado !== true), period);
        // console.log(`Diferença percentual: ${variationNumberOrdersInProgress.toFixed(2)}%`);
        setVariationNumberOrdersInProgress(variationNumberOrdersInProgress)


        const total = dataNew.length;
        const finalizado = dataNew.filter((os: any) => os.finalizado === true).length
        const regular = dataNew.filter((os: any) => os.regularidade === 'regular').length
        const irregular = dataNew.filter((os: any) => os.regularidade === 'irregular').length

        setProcessosTotal(total)
        setProcessosRegulares(regular)
        setProcessosIrregulares(irregular)
        setProcessosFinalizados(finalizado)
        setProcessosAndamento(total - finalizado)

      }).catch((err) => {
        console.log(err)
      })

      // tempo medio de resolução
      const [year, month] = selectedPeriod.split('/').map(Number);
      await getOsAVGRes(year, month).then((res: any) => {

        if (res.data.length === 0) {
          setProcessosTempoMedio(0)
          setCompletaTempoMedio(0)
          setRemotaTempoMedio(0)
          setPericiaTempoMedio(0)
          return
        } else {
          let totalTempo = res.data[0].total;
          let remotaTempo = res.data[0].remota;
          let completaTempo = res.data[0].completa;
          let periciaTempo = res.data[0].pericia;
  
          totalTempo = (!totalTempo) ? '0' : (totalTempo / 3600000 / 24).toFixed(0);
          remotaTempo = (!remotaTempo) ? '0' : (remotaTempo / 3600000 / 24).toFixed(0);
          completaTempo = (!completaTempo) ? '0' : (completaTempo / 3600000 / 24).toFixed(0);
          periciaTempo = (!periciaTempo) ? '0' : (periciaTempo / 3600000 / 24).toFixed(0);
  
          setProcessosTempoMedio(totalTempo);
          setCompletaTempoMedio(completaTempo);
          setRemotaTempoMedio(remotaTempo);
          setPericiaTempoMedio(periciaTempo);
        } 



      }).catch((err) => {
        console.log(err)
      })

      // dados do grafico de O.S. por mês
      const responseOsMonthly = await getOsMonthly().then((res: any) => {
        return res.data;
      }).catch((err) => {
        console.log(err)
      })

      const label: Array<string> = []
      const remota: Array<number> = []
      const completa: Array<number> = []
      const pericia: Array<number> = []

      // Ordenar os dados pelo campo _id no formato "YYYY / MM"
      responseOsMonthly.sort((a: any, b: any) => {
        const [yearA, monthA] = a._id.split(' / ').map(Number);
        const [yearB, monthB] = b._id.split(' / ').map(Number);

        if (yearA !== yearB) {
          return yearA - yearB;
        }
        return monthA - monthB;
      });

      await responseOsMonthly.map((res: any) => {
        label.push(res._id)
        remota.push(res.remota)
        completa.push(res.completa)
        pericia.push(res.pericia)
      })
      setLabelChart(label)
      setDataCompletaChart(completa)
      setDataRemotaChart(remota)
      setDataPericiaChart(pericia)
    }

    getData();

  }, [selectedPeriod])

  // useEffect(() => {
  //   async function getData() {
  //     await getOsFromUser().then(res => {
  //       const dataNew = res.data.rows.filter((order: { createdAt: string | number | Date; }) => {
  //         const createdAt = new Date(order.createdAt);
  //         const [year, month] = selectedPeriod.split('/').map(Number);
  //         return createdAt.getFullYear() === year && createdAt.getMonth() + 1 === month;
  //       });
  //       setData(dataNew);
  //       const variation = getMonthlyOrderPercentageDifference(res.data.rows, selectedPeriod);
  //       setVariationNumberOrders(variation);
  //     }).catch(err => console.log(err));
  //   }
  //   if (selectedPeriod) {
  //     getData();
  //   }
  // }, [selectedPeriod]);

  return (
    <Template path={'home'}>
      <div className='container' id='dashboard'>

        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4" style={{ marginBottom: '15px' }}>
              <label><strong>Filtrar por Mês/Ano:</strong></label>
              <select
                className="form-control"
                value={selectedPeriod}
                onChange={(e) => setSelectedPeriod(e.target.value)}
              >
                {availablePeriods.map((period) => (
                  <option key={period} value={period}>{period}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
            {/*}
            <div className="col-md-3">
              <WidgetCard
                title={'Total mês'}
                value={'0'}
                percentual={'0%'}
                info={'Comparado a (0 mês anterior)'}
              />
            </div>
            */}
            <div className="col-md-4">
              <WidgetCard
                title={i18n.t('home.total processes')}
                value={String(processosTotal)}
                percentual={String(`${variationNumberOrders.toFixed(2)}%`)}
                info={i18n.t('home.compared to (0 previous month)')}
              />
            </div>
            <div className="col-md-4">
              <WidgetCard
                title={i18n.t('home.processes completed')}
                value={String(processosFinalizados)}
                percentual={String(`${variationNumberCompletedOrders.toFixed(2)}%`)}
                info={i18n.t('home.compared to (0 previous month)')}
              />
            </div>
            <div className="col-md-4">
              <WidgetCard
                title={i18n.t('home.processes in progress')}
                value={String(ProcessosAndamento)}
                percentual={String(`${variationNumberOrdersInProgress.toFixed(2)}%`)}
                info={i18n.t('home.compared to (0 previous month)')}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-7">
              <WidgetChartGroupedBar
                title={i18n.t('home.total completed')}
                label={labelChart}
                completa={dataCompletaChart}
                remota={dataRemotaChart}
                pericia={dataPericiaChart}
              />
            </div>
            <div className="col-md-5">
              <WidgetChartDoughnut
                title={i18n.t('home.average execution time')}
                processosTempoMedio={processosTempoMedio}
                completaTempoMedio={completaTempoMedio}
                remotaTempoMedio={remotaTempoMedio}
                periciaTempoMedio={periciaTempoMedio}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-7">
              <WidgetMap data={data || []} />
            </div>
            <div className="col-md-5">
              <WidgetChartProcess
                title={i18n.t('home.processes')}
                processosTotal={processosTotal}
                processosRegulares={processosRegulares}
                processosIrregulares={processosIrregulares}
              />
            </div>
          </div>
        </div>
      </div>
    </Template>
  )
}
